import React from "react";
import { withRouter, Link as RouterLink } from "react-router-dom";
import i18n from "i18next";
import { Placeholder } from "@sitecore-jss/sitecore-jss-react";
import { connect } from "react-redux";

import { api } from "@/utils/api";
import LPMain from "@/react-components/LPMain";
import QAListItem from "@/react-components/QAListItem";
import NewsReleaseListItem from "@/react-components/NewsReleaseListItem";
import url from "@/utils/url";
import { modeEnum } from "@/utils/enum";
import { debounce, isIEBrowser } from "@/utils";

class LPInfoSection extends React.Component {
  constructor(props) {
    super(props);

    this.originalSplashButtonRect = {
      left: 90,
      bottom: 124,
      width: 250,
      height: 50,
    };

    this.state = {
      qaList: [],
      newsReleaseList: [],
      splashButtonRect: { ...this.originalSplashButtonRect },
      qaIsShowMore: false,
      paymentServiceStarted: false,
    };

    this.resizeDebounce = debounce(this.resize);
    this.splashRef = React.createRef();
  }

  componentDidMount() {
    window.addEventListener("resize", this.resizeDebounce);
    this.fetchNewsReleaseData();
    this.fetchQAData();
    this.fetchTime();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resizeDebounce);
    this.resizeDebounce.cancel();
  }

  fetchNewsReleaseData = () => {
    api.lp
      .getNewsReleaseList({
        pageindex: 1,
        pagesize: 3,
      })
      .then((response) => {
        this.setState({
          newsReleaseList: response.list,
        });
      })
      .catch((error) => {
        console.error("error: " + error.message);
      });
  };

  fetchQAData = () => {
    api.lp
      .getQAList()
      .then((response) => {
        this.setState({
          qaList: response,
        });
      })
      .catch((error) => {
        console.error("error: " + error.message);
      });
  };

  fetchTime = () => {   
    const serviceStartDate = new Date(i18n.t("TCCs0018_lp_payment_service_start_datetime"));
    api.common
      .getTime()
      .then((response) => {
        const paymentServiceStarted = new Date(response) >= serviceStartDate;
        this.setState({ paymentServiceStarted });
      })
      .catch((error) => {
        console.error("error: " + error.message);
      });
  };
  onSplashLoad = () => {
    this.resize();
  };

  resize = () => {
    const ratio = this.splashRef.current.clientWidth / 1080;
    const { left, bottom, width, height } = this.originalSplashButtonRect;

    this.setState({
      splashButtonRect: {
        left: Math.floor(left * ratio),
        bottom: Math.floor(bottom * ratio),
        width: Math.ceil(width * ratio),
        height: Math.ceil(height * ratio),
      },
    });
  };

  register = () => {
    const {
      history: { push },
    } = this.props;
    push(url.confirmAgreement);
  };

  // 課金-ADD-START
  paymentPlaceholderRender = (components) => {
    const { scMode } = this.props;
    if (scMode === modeEnum.pageEditing) {
      return <React.Fragment key={Math.random()}>{components}</React.Fragment>;
    }
    return components.filter((item) => item?.props?.fields?.isAvailable?.value);
  };
  // 課金-ADD-END

  render() {
    const {
      qaList,
      newsReleaseList,
      splashButtonRect: { left, bottom, width, height },
      qaIsShowMore,
      paymentServiceStarted,
    } = this.state;
    const { routeData } = this.props;

    return (
      <LPMain className="lp-info-container" isShowRedBar={isIEBrowser()}>
        <div className="lp-info-container-splash" ref={this.splashRef}>
          <img
            className="lp-info-container-splash-image"
            alt=""
            src={require("@/assets/images/lp-splash.png")}
            onLoad={this.onSplashLoad}
          />
        </div>
        <div className="lp-info-container-news">
          <div className="lp-info-container-news-small-title">News</div>
          <div className="lp-info-container-news-title">
            {i18n.t("TCCs0018_lp_news_title")}
          </div>
          <div className="lp-info-container-news-content">
            {newsReleaseList.map((item, index) => (
              <NewsReleaseListItem key={index} data={item} />
            ))}
          </div>
          <div className="lp-info-container-news-more">
            <RouterLink to={url.lpNews}>
              {i18n.t("TCCs0018_lp_news_more_title")}
              <img alt="" src={require("@/assets/images/arrow-right.svg")} />
            </RouterLink>
          </div>
        </div>
        <div className="lp-info-container-service">
          <div className="lp-info-container-service-small-title">Service</div>
          <div className="lp-info-container-service-title">
            {i18n.t("TCCs0018_lp_service_title")}
          </div>
          <div
            className="lp-info-container-service-description"
            dangerouslySetInnerHTML={{
              __html: i18n.t("TCCs0018_lp_service_description"),
            }}
          />
          <div className="lp-info-container-service-image">
            <img alt="" src={require("@/assets/images/lp_service.png")} />
          </div>
          <div className="lp-info-container-service-placeholder">
            <Placeholder
              name="jss-service"
              rendering={routeData}
              routeData={routeData}
            />
          </div>
          <div className="lp-info-container-service-button-register">
          </div>
        </div>
        {/* 課金-ADD-START */}
        {paymentServiceStarted && (
        <div className="lp-info-container-payment">
          <div className="lp-info-container-payment-container">
            <div className="lp-info-container-payment-small-title">Option</div>
            <div className="lp-info-container-payment-title">
              {i18n.t("TCCs0018_lp_payment_title")}
            </div>
            <div
              className="lp-info-container-payment-description"
              dangerouslySetInnerHTML={{
                __html: i18n.t("TCCs0018_lp_payment_description"),
              }}
            />
            <div
              className="lp-info-container-payment-sub-description"
              dangerouslySetInnerHTML={{
                __html: i18n.t("TCCs0018_lp_payment_sub_description"),
              }}
            />
            <div className="lp-info-container-payment-placeholder">
              <Placeholder
                name="jss-payment"
                rendering={routeData}
                routeData={routeData}
                render={this.paymentPlaceholderRender}
              />
            </div>
            <div
              className="lp-info-container-payment-remark"
              dangerouslySetInnerHTML={{
                __html: i18n.t("TCCs0018_lp_payment_remark"),
              }}
            />
            <div
              className="lp-info-container-payment-compare-title"
              dangerouslySetInnerHTML={{
                __html: i18n.t("TCCs0018_lp_payment_compare_title"),
              }}
            />
            <div className="lp-info-container-payment-compare-placeholder">
              <Placeholder
                name="jss-payment-compare"
                rendering={routeData}
                routeData={routeData}
              />
            </div>
            <div className="lp-info-container-payment-button-register">
            </div>
          </div>
        </div>
        )}
        {/* 課金-ADD-END */}
        <div className="lp-info-container-qa">
          <div className="lp-info-container-qa-small-title">FAQ</div>
          <div className="lp-info-container-qa-title">
            {i18n.t("TCCs0018_lp_qa_title")}
          </div>
          <div className="lp-info-container-qa-content">
            {qaList
              .filter((_, index) => index < 4)
              .map((item, index) => (
                <QAListItem key={index} data={item} />
              ))}
          </div>
          {qaList.length > 4 ? (
            <div className="lp-info-container-qa-more">
              <button
                onClick={() => this.setState({ qaIsShowMore: !qaIsShowMore })}
              >
                {i18n.t("TCCs0018_lp_qa_more_title")}
                <img
                  alt=""
                  src={require(`@/assets/images/lp_ic_arrow_${
                    qaIsShowMore ? "up" : "down"
                  }.svg`)}
                />
              </button>
            </div>
          ) : null}
          {qaIsShowMore ? (
            <div className="lp-info-container-qa-more-content">
              {qaList
                .filter((_, index) => index >= 4)
                .map((item, index) => (
                  <QAListItem key={index} data={item} />
                ))}
            </div>
          ) : null}
          <div className="lp-info-container-qa-button-register">
          </div>
        </div>
      </LPMain>
    );
  }
}

// 課金-ADD-START
const mapStateToProps = (state) => {
  return {
    scMode: state?.config?.mode,
  };
};
// 課金-ADD-END

// 課金-UPD-START
export default connect(mapStateToProps)(withRouter(LPInfoSection));
// 課金-UPD-END
